import {GameTime} from './GameTime';
import {Disposable} from './Disposable';

export function wait(milliseconds:number)
{
    return new Promise(resolve => {
        const tick = Disposable.fromPropertySubscription(GameTime.gameTick, (elapsed) => {
            if ((milliseconds -= elapsed) <= 0)
            {
                tick.dispose();
                resolve();
            }
        });
    });
}